module.exports = __webpack_public_path__ + "img/_54A6743_t.0477ad70.jpg";